module.exports = __webpack_public_path__ + "img/uid-login.92d9c38a.png";